<template>
  <div class="container">
    <head-nav-bar
      :title="
        hospitalInFo.name == '北流市中医医院'
          ? hospitalInFo.name + ' 检验报告明细'
          : '检验报告明细'
      "
      :fixed="true"
      @click-left="onLeftClick"
    />
    <div class="mt-header-nav">
      <div class="box">
        <cell-box>
          <!-- <cell-item label="订单编号：" :value="info.BillNo" /> -->
          <cell-item label="姓名：" :value="info.patientName" />
          <cell-item label="性别：" :value="info.patientSex" />
          <cell-item label="年龄：" :value="info.patientAge" />
          <cell-item label="检验项目：" :value="info.examPurpose" />
        </cell-box>

        <table class="report-table" border="0" cellspacing="0" cellpadding="0">
          <thead>
            <tr>
              <th style="text-align:left;">项目名称</th>
              <th>项目编号</th>
              <th>结果</th>
              <th></th>
              <th>参考值</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in info.items" :key="index">
              <td style="text-align:left;">{{ item.examItemName }}</td>
              <td>{{ item.examItemCode }}</td>
              <td>{{ item.result }}</td>
              <td>
                <span v-if="item.result_Desc == 'H'">↑</span>
                <span v-if="item.result_Desc == 'L'">↓</span>
              </td>
              <td>{{ item.referenceValue }}</td>
            </tr>
          </tbody>
        </table>

        <cell-box>
          <cell-item label="检查时间：" :value="info.examTime" />
          <cell-item label="报告时间：" :value="info.reportTime" />
          <cell-item label="" :value="hospitalInFo.fullName" />
        </cell-box>
      </div>
    </div>
  </div>
</template>

<script>
import { Button, Icon, NoticeBar } from "vant";
import { CellBox, CellItem } from "@/components/cell";

export default {
  name: "userReportInfo",
  components: {
    CellBox,
    CellItem,
    [Button.name]: Button,
    [Icon.name]: Icon,
    [NoticeBar.name]: NoticeBar
  },

  data() {
    return {
      Id: "",
      ReqNo: "",
      type: 1,
      info: {},
      canCancel: false,
      hospitalInFo: {},
      DiagnosisCardNo: "",
      InpatientId: ""
    };
  },
  created() {
    this.getHospitalInFo();
    this.Id = this.$route.query.Id;
    this.ReqNo = this.$route.query.ReqNo;
    this.type = this.$route.query.type;
    this.DiagnosisCardNo = this.$route.query.DiagnosisCardNo;
    this.InpatientId = this.$route.query.InpatientId;

    if (this.Id && this.ReqNo) {
      this.getInfo();
    }
  },
  methods: {
    getHospitalInFo() {
      this.$post("Hospital_Info").then(res => {
        this.hospitalInFo = res.data;
      });
    },
    getInfo() {
      this.$post("MyReport_InspectionDetail", {
        ReportId: this.Id,
        ReqNo: this.ReqNo
      }).then(res => {
        this.info = res.data;
      });

      //this.info.CanPay = true;
    },
    onLeftClick() {
      this.$router.push({
        name: "userInHospitalizationReport",
        query: {
          tab: this.type,
          DiagnosisCardNo: this.DiagnosisCardNo,
          InpatientId: this.InpatientId
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.report-table {
  font-size: 0.35rem;
  width: 100%;
  border: 1px solid #ddd;
  thead {
    th {
      background: #f1f1f1;
      text-align: center;
      padding: 5px;
    }
  }
  tbody {
    tr {
      td {
        text-align: center;
        padding: 5px;
        border-bottom: 1px solid #f1f1f1;
      }
    }
  }
}
</style>
